import { IQuestionListItem, IPaperData } from '@/types';
import { message } from 'antd';
import React, { createContext, useContext, ReactNode } from 'react';

// 定义包含多个函数的对象类型
interface AppProviderType {
    answerFunction?: (message: IQuestionListItem) => void;
    openEquityModal?: (message: IQuestionListItem) => void;
    submitCallback?: (paperData: IPaperData) => void;
    singleQuestionCallback?: (message?: IQuestionListItem) => void;
    pushQuestionCallback?: (paperDataLogId: number) => void;
    businessParam: any;
    questionBusinessParamMap: any;
    sourceFromType?: number;
}

// 创建一个Context并设置默认值为undefined
const functionContext = createContext<AppProviderType | undefined>(undefined);

// 创建一个自定义钩子来使用Context
export const useAppContext = (): AppProviderType => {
    const context = useContext(functionContext);

    const defaultAnswerFunction = () => {
        // 默认函数 当然你不写也行
        message.info('暂无权限答疑');
    };

    const defaultHandleOpenEquityModal = () => {
        // 默认函数 当然你不写也行
    };

    return {
        businessParam: {},
        questionBusinessParamMap: {},
        ...context,
        answerFunction: context?.answerFunction || defaultAnswerFunction,
        openEquityModal: context?.openEquityModal || defaultHandleOpenEquityModal,
        pushQuestionCallback: context?.pushQuestionCallback,
    };
};

// 创建一个Provider组件
interface FunctionProviderProps {
    children: ReactNode;
    value: AppProviderType;
}

export const AppProvider: React.FC<FunctionProviderProps> = ({ children, value }) => {
    return <functionContext.Provider value={value}>{children}</functionContext.Provider>;
};
